import { isEmpty, orderBy, cloneDeep } from 'lodash';
import * as moment from 'moment';

import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import PlacesIcon from '@material-ui/icons/LocationSearching';
import ExploreIcon from '@material-ui/icons/Explore';
import SportsEsportsIcon from '@material-ui/icons/SportsEsports';
import HomeIcon from '@material-ui/icons/Home';
import FileCopyIcon from '@material-ui/icons/FileCopy';
// import DonutSmallIcon from '@material-ui/icons/DonutSmall';

import PlannerPage from '../organisms/PlannerPage';
import ProvidersPage from '../organisms/ProvidersPage';
import RoutesPage from '../organisms/RoutesPage';
import PlacesPage from '../organisms/PlacesPage';
import MoreToExploreCollectionPage from '../organisms/MoreToExploreCollectionPage';
import SparksPage from '../organisms/SparksPage';
import VirtualsPage from '../organisms/VirtualsPage';
import BulkActionsPage from '../organisms/BulkActionsPage';
// import MicroexperienceManagerPage from '../Microexperience/MicroexperienceManagerPage';
import ACFilter from '../molecules/filters/ACFilter';
import config from '../../config/config';

import colors from '../common/colors';
// getFilterBarItems returns the default

// Used to simulate different timezones
// eg Canada: moment.tz.setDefault("America/Vancouver");
// moment.tz.setDefault("Australia/Melbourne");

const getFilterBarItems = () => {
    return {
        planner: {
            component: ACFilter,
        },
        providers: {
            component: ACFilter,
        },
        routes: {
            component: ACFilter,
        },
        places: {
            component: ACFilter,
        },
        'more to explore': {
            component: ACFilter,
        },
    };
};

// getFilterBarItems returns the default
const getOptionalFilterControls = () => {
    return {
        planner: {
            optionalFilterControls: [
                'hqId',
                // 'providerStatuses', // Hidden until further descion is made
                'bookingStatuses',
                'routeSet',
                'confirmationSent',
                'codeSent',
                'authStatus',
                'owners',
                'productCategories',
                'subscriptionStatus',
                'isPersonalisationCompleted',
                'surveyCompleted',
            ],
        },
        providers: {
            optionalFilterControls: ['days'],
        },
        routes: {
            optionalFilterControls: ['days', 'dietaries', 'owners'],
        },
    };
};

// Get statuses based on different UI screens
const statuses = {
    provider: ['active', 'inactive', 'archived'],
    booking: ['enquired', 'draft', 'quoted', 'requested', 'tentative', 'booked', 'confirmed', 'completed', 'declined','cancelled','reschedulerequested','postponed'],
    providerBooking: ['confirmed', 'requested', 'declined'],
    clue: ['active', 'inactive', 'archived'],
    route: ['active', 'inactive', 'archived'],
    stop: ['active', 'inactive', 'archived'],
    hq: ['requested', 'accepted', 'declined'],
    place: ['active', 'inactive', 'archived'],
    moreToExplore: ['active', 'inactive', 'archived'],
    spark: ['active', 'inactive', 'archived', 'in progress'],
    virtual: ['active', 'inactive', 'archived'],
};

const getBookingItemPaymentStatuses = () => {
    const statuses = [
        {
            name: 'Direct Debit Expected',
            value: 'directDebitExpected',
            showOnProvider: false,
            showOnPlanner: true,
        },
        {
            name: 'Awaiting Invoice',
            value: 'awaitingInvoice',
            showOnProvider: true,
            showOnPlanner: true,
        },
        {
            name: 'Invoice Received',
            value: 'invoiceReceived',
            showOnProvider: false,
            showOnPlanner: false,
        },
        {
            name: 'Call To Pay',
            value: 'callToPay',
            showOnProvider: false,
            showOnPlanner: false,
        },
        /*
         * That is what it used to be before 05/03/2020
         */
        // {
        //   name: 'Paid',
        //   value: 'paid',
        //   showOnProvider: false,
        //   showOnPlanner: false,
        // },

        {
            name: 'Reconciled',
            value: 'reconciled',
            showOnProvider: false,
            showOnPlanner: true,
        },

        {
            name: 'Not Charged',
            value: 'notCharged',
            showOnProvider: false,
            showOnPlanner: false,
        },

        {
            name: 'CC Payment Over the Phone Required',
            value: 'ccPaymentOverThePhoneRequired',
            showOnProvider: true,
            showOnPlanner: true,
        },
        {
            name: 'Bank Transfer Required',
            value: 'bankTransferRequired',
            showOnProvider: true,
            showOnPlanner: true,
        },
        {
            name: 'Payment in Person Required',
            value: 'paymentInPersonRequired',
            showOnProvider: true,
            showOnPlanner: true,
        },
        {
            name: 'Invoice Received and Sent to Accounting',
            value: 'invoiceReceivedAndSentToAccounting',
            showOnProvider: false,
            showOnPlanner: false,
        },
        {
            name: 'Payment made via kitty',
            value: 'paid',
            showOnProvider: true,
            showOnPlanner: true,
        },
        {
            name: 'Provider will charge our CC',
            value: 'providerWillChargeOurCC',
            showOnProvider: true,
            showOnPlanner: true,
        },
        {
            name: 'Provider has confirmed via PSP and have charged our card',
            value: 'paymentConfirmedViaPSP',
            showOnProvider: false,
            showOnPlanner: true,
        },
        {
            name: 'Reconciled - invoice paid',
            value: 'reconciledInvoicePaid',
            showOnProvider: false,
            showOnPlanner: true,
        },
        {
            name: 'We pay via PSP',
            value: 'wePayViaPSP',
            showOnProvider: true,
            showOnPlanner: true,
        },
        {
            name: 'Payment via PayPal',
            value: 'paymentViaPaypal',
            showOnProvider: true,
            showOnPlanner: true,
        },
        {
            name: 'No Payment Required',
            value: 'noPaymentRequired',
            showOnProvider: true,
            showOnPlanner: true,
        },
        {
            name: 'Expecting Refund',
            value: 'expectingRefund',
            showOnProvider: false,
            showOnPlanner: true,
        },
        {
            name: 'Reconciled - Refund Received',
            value: 'reconciledRefundReceived',
            showOnProvider: false,
            showOnPlanner: true,
        },
    ];

    return orderBy(statuses, ['name'], ['asc']);
};

const getBookingItemActivityStatuses = () => {
    const statuses = [
        {
            name: 'No Booking Required',
            value: 'noBookingRequired',
            showOnProvider: true,
            showOnPlanner: true,
        },
        {
            name: 'Needs Booking',
            value: 'needsBooking',
            showOnProvider: false,
            showOnPlanner: false,
        },
        {
            name: 'Booking Requested',
            value: 'bookingRequested',
            showOnProvider: false,
            showOnPlanner: true,
        },
        {
            name: 'Needs Rebooking',
            value: 'needsRebooking',
            showOnProvider: false,
            showOnPlanner: false,
        },

        {
            name: 'Booked',
            value: 'booked',
            showOnProvider: false,
            showOnPlanner: true,
        },

        {
            name: 'Completed',
            value: 'completed',
            showOnProvider: false,
            showOnPlanner: true,
        },

        {
            name: 'Declined',
            value: 'declined',
            showOnProvider: false,
            showOnPlanner: false,
        },

        {
            name: 'Canceled',
            value: 'canceled',
            showOnProvider: false,
            showOnPlanner: true,
        },
        {
            name: 'Call to Book',
            value: 'callToBook',
            showOnProvider: true,
            showOnPlanner: true,
        },
        {
            name: 'Email to Book',
            value: 'emailToBook',
            showOnProvider: true,
            showOnPlanner: true,
        },
        {
            name: 'Provider Confirms in PSP',
            value: 'confirmed',
            showOnProvider: true,
            showOnPlanner: true,
        },
        {
            name: 'Book via Website',
            value: 'bookViaWebsite',
            showOnProvider: true,
            showOnPlanner: true,
        },
        {
            name: 'Provider accepted in PSP',
            value: 'accepted',
            showOnProvider: false,
            showOnPlanner: true,
        },
        {
            name: 'Provider declined in PSP',
            value: 'declined',
            showOnProvider: false,
            showOnPlanner: true,
        },
        {
            name: 'Customer Arrived',
            value: 'customerArrived',
            showOnProvider: false,
            showOnPlanner: true,
        },
        {
            name: 'Text to Book',
            value: 'textToBook',
            showOnProvider: true,
            showOnPlanner: true,
        },
        {
            name: 'Facebook Message to Book',
            value: 'facebookMessageToBook',
            showOnProvider: true,
            showOnPlanner: true,
        },
    ];

    return orderBy(statuses, ['name'], ['asc']);
};

const getProviderBookingStatuses = () => {
    const providerBookingStatusArray = [];
    getBookingItemActivityStatuses().forEach((status) => {
        if (status.showOnPlanner) providerBookingStatusArray.push(status.name);
    });
    return providerBookingStatusArray;
};

const getProviderPaymentStatus = () => {
    const providerPaymentStatusArray = [];
    getBookingItemPaymentStatuses().forEach((status) => {
        if (status.showOnPlanner) providerPaymentStatusArray.push(status.name);
    });
    return providerPaymentStatusArray;
};

const getDays = () => {
    return ['Saturday', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
};

const getDietaries = () => {
    return ['Vegetarian', 'Vegan', 'Gluten Free'];
};

const getStatuses = (key) => {
    return statuses[key];
};

const getProductCategories = () => {
    return ['external', 'internal', 'shipping', 'digital'];
};

const getSubscriptionStatus = () => {
    return ['Active', 'Cancelled'];
};

const getSubscriptionTier = () => {
    return ['Standard', 'Premium', 'Free Forever'];
};

// If we pass the object and key, it will return the value.
const findKeyByValue = (obj, value) => {
    let key = '';
    if (obj && !isEmpty(obj)) {
        Object.entries(obj).forEach((entry) => {
            if (entry && entry.length >= 2) {
                if (entry[1] === value) key = entry[0];
            }
        });
    }
    return key;
};

// For payment status, we want to remove the $ amount
const findPaymentKeyByValue = (obj, value) => {
    let paymentValue = '';
    let delimiter = value.indexOf(':');
    if (delimiter > -1) {
        paymentValue = value.substring(0, delimiter);
    }
    return findKeyByValue(obj, paymentValue);
};

// If we pass the object and value, it will return the key.
const findValueByKey = (obj, key) => {
    let value = '';
    if (obj && !isEmpty(obj)) {
        Object.entries(obj).forEach((entry) => {
            if (entry && entry.length >= 2) {
                if (entry[0] === key) value = entry[1];
            }
        });
    }
    return value;
};

const getConfirmationSentValues = () => {
    return ['Yes', 'No','Queued'];
};
const getSimpleFilters = () => {
    return ['Yes', 'No'];
};

const getCodeSentValues = () => {
    return ['Yes', 'No','Queued'];
};

const getCodeSentValuesArray = () => {
    return [{label:'Yes',value:true}, { label:'No',value:false},{ label:'Queued',value:"queued"}];
};
const providerItemStatusArray =()=>{
    return [
        {
            label:'Not Complete',
            value:'not-complete'
        },
        {
            label:'Completed',
            value:'completed'
        },
        {
            label:'Not Requested',
            value:'not-requested'
        },
        {
            label:'Requested/Completed',
            value:'requested-completed'
        }
    ]

} 

const getRouteSetValues = () => {
    return ['Yes', 'No'];
};

const getAuthStatusValues = () => {
    return ['Not set', 'In progress', 'Available'];
};

// getFirstCharCap converts the first letter to capital and return it
const getFirstCharCap = (string) => {
    if (isEmpty(string)) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
};

// getFirstCharLower converts the first letter to lower and return it
// TODO: not sure if we need this one instead of just `toLowerCase` the whole string
const getFirstCharLower = (string) => {
    if (isEmpty(string)) return '';
    return string.charAt(0).toLowerCase() + string.slice(1);
};

// getDecimalNumber convert a number to a trailing specific decimal place
const getDecimalNumber = (number, decimalPlaces) => {
    return parseFloat(Math.round(number * 100) / 100).toFixed(decimalPlaces);
};

// getStatusStyle
const getStatusStyle = (key, styles) => {
    const dictionary = {
        Available: styles.available,
        Unavailable: styles.unavailable,
        Active: styles.active,
        Create: styles.create,
        ReadyToUse: styles.readyToUse,
        Clue: styles.clue,
    };
    return dictionary[key];
};

const getPaymentStatusStyle = (status) => {
    let style = {
        backgroundColor: '#52A8EF',
        color: 'white',
        borderColor: '#616161',
        borderWidth: '1px',
        borderStyle: 'none',
        dotColor: '',
        borderRadius: '16px',
    };
    if (isEmpty(status)) return style;
    switch (status.toUpperCase()) {
        // Direct Debit Expected
        case 'DIRECTDEBITEXPECTED':
            style.backgroundColor = 'white';
            style.color = '#616161';
            style.dotColor = '#52A8EF';
            style.borderStyle = 'solid';
            break;

        // Awaiting Payment
        case 'AWAITINGINVOICE':
            style.backgroundColor = 'white';
            style.color = '#616161';
            style.borderStyle = 'solid';
            style.dotColor = '#FF765F';
            break;

        // Invoice Received
        case 'INVOICERECEIVED':
            style.backgroundColor = 'white';
            style.color = '#616161';
            style.borderStyle = 'solid';
            style.dotColor = '#7ED321';
            break;

        // Call to Pay
        case 'CALLTOPAY':
            style.backgroundColor = '#52A8EF';
            style.color = 'white';
            style.borderStyle = 'none';
            break;

        // Paid
        case 'PAID':
            style.backgroundColor = '#7ED321';
            style.color = 'white';
            style.borderStyle = 'none';
            break;

        // Reconciled
        case 'RECONCILED':
            style.backgroundColor = '#3E424B';
            style.color = 'white';
            style.borderStyle = 'none';
            break;

        // Not Charged
        case 'NOTCHARGED':
            style.backgroundColor = '#E0E0E0';
            style.color = 'white';
            style.borderStyle = 'none';
            break;
        default:
            break;
    }
    return style;
};

const getActivityStatusStyle = (status) => {
    let style = {
        backgroundColor: '#52A8EF',
        color: 'white',
        borderColor: '#616161',
        borderWidth: '1px',
        borderStyle: 'none',
        dotColor: '',
        borderRadius: '16px',
    };
    if (isEmpty(status)) return style;
    switch (status.toUpperCase()) {
        // No Booking Required
        case 'NOBOOKINGREQUIRED':
            style.backgroundColor = 'white';
            style.color = '#616161';
            style.borderStyle = 'solid';
            break;

        // Needs Booking
        case 'NEEDSBOOKING':
            style.backgroundColor = '#FFD45F';
            style.color = 'white';
            style.borderStyle = 'none';
            break;

        // Booking Requested
        case 'BOOKINGREQUESTED':
            style.backgroundColor = '#52A8EF';
            style.color = 'white';
            style.borderStyle = 'none';
            break;

        // Needs Rebooking
        case 'CALLTOBOOK':
        case 'EMAILTOBOOK':
        case 'BOOKVIAWEBSITE':
        case 'NEEDSREBOOKING':
            style.backgroundColor = '#FF765F';
            style.color = 'white';
            style.borderStyle = 'none';
            break;

        // Booked
        case 'BOOKED':
            style.backgroundColor = '#7ED321';
            style.color = 'white';
            style.borderStyle = 'none';
            break;

        // Completed
        case 'Completed':
            style.backgroundColor = '#3E424B';
            style.color = 'white';
            style.borderStyle = 'none';
            break;

        // Declined
        case 'DECLINED':
            style.backgroundColor = '#E0E0E0';
            style.color = 'white';
            style.borderStyle = 'none';
            break;

        // Booked
        case 'CANCELED':
            style.backgroundColor = '#E0E0E0';
            style.color = 'white';
            style.borderStyle = 'none';
            break;

        default:
            break;
    }
    return style;
};

// getFilterStr is a generic function building query string to be sent to server
const getFilterStr = (filter) => {
    let filterStr = '';
    if (!isEmpty(filter)) {
        if (filter.countries && filter.countries.length > 0) {
            let countries = filter.countries;
            countries.forEach((country) => {
                filterStr += '&countries=' + country;
            });
        }

        if (filter.states && filter.states.length > 0) {
            let states = filter.states;
            states.forEach((state) => {
                filterStr += '&states=' + state;
            });
        }

        if (filter.cities && filter.cities.length > 0) {
            let cities = filter.cities;
            cities.forEach((city) => {
                filterStr += '&cities=' + city;
            });
        }

        if (filter.owners && filter.owners.length > 0) {
            let owners = filter.owners;
            owners.forEach((owner) => {
                filterStr += '&userIds=' + owner;
            });
        }

        if (filter.days && filter.days.length > 0) {
            let days = filter.days;
            days.forEach((day) => {
                filterStr += '&days=' + day;
            });
        }

        if (filter.dietaries && filter.dietaries.length > 0) {
            let dietaries = filter.dietaries;
            dietaries.forEach((diet) => {
                filterStr += '&dietaries=' + diet;
            });
        }

        if (filter.hqId && !isEmpty(filter.hqId)) {
            let hqId = filter.hqId;
            filterStr += '&query=' + hqId;
        }

        if (filter.bookingStatuses && filter.bookingStatuses.length > 0) {
            let bookingStatuses = filter.bookingStatuses;
            bookingStatuses.forEach((status) => {
                if (status) filterStr += '&bookingStatuses=' + status.toLowerCase();
            });
        }

        if (filter.bookingDate) {
            let bookingDate = filter.bookingDate;

            if (bookingDate) {
                if (bookingDate.from && !isEmpty(bookingDate.from)) {
                    let bookingDateFrom = moment(bookingDate.from);
                    const startDate = bookingDateFrom.clone();
                    // console.log("startDate:", startDate.format());

                    // get timezone in hh:mm format
                    let timezoneOffset = startDate.format('Z');
                    // convert timezone into hours
                    let offsetHours = moment.duration(timezoneOffset).asHours();
                    let absoluteHours = Math.abs(offsetHours);
                    let adjustedDate = startDate;

                    // singularity bookings in countries behind UTC time will be saved in mongoDB as UTC + offset
                    // subtracting this offset and another 12 hours will guarantee they see bookings in Aus which are saved
                    // in mongo in UTC - offset (eg Aus bookings are saved in mongo minus 10 hours, we want to capture those)
                    adjustedDate = moment(startDate)
                        .subtract(absoluteHours + 12, 'hours')
                        .format();

                    // console.log("offsetHours: ", offsetHours);
                    // console.log("adjustedDate: ", adjustedDate);

                    filterStr += '&from=' + adjustedDate;
                }

                if (bookingDate.to && !isEmpty(bookingDate.to)) {
                    let date = moment(bookingDate.to).clone().endOf('day').format();
                    filterStr += '&to=' + date;
                }
            }
        }

        if (filter.confirmationSent && filter.confirmationSent.length > 0) {
            let confirmationSent = filter.confirmationSent;
            confirmationSent.forEach((val) => {
                if (val) filterStr += '&isConfirmationSent=' + val.toLowerCase();
            });
        }

        if (filter.codeSent && filter.codeSent.length > 0) {
            let codeSent = filter.codeSent;
            codeSent.forEach((val) => {
                if (val) filterStr += '&isCodeSent=' + val.toLowerCase();
            });
        }

        if (filter.isPersonalisedCompleted && filter.isPersonalisedCompleted.length > 0) {
            let isPersonalisedCompleted = filter.isPersonalisedCompleted;
            isPersonalisedCompleted.forEach((val) => {
                if (val) filterStr += '&isPersonalisationDone=' + val.toLowerCase();
            });
        }

        if (filter.surveyCompleted && filter.surveyCompleted.length > 0) {
            let surveyCompleted = filter.surveyCompleted;
            surveyCompleted.forEach((val) => {
                if (val) filterStr += '&surveyCompleted=' + val.toLowerCase();
            });
        }

        if (filter.routeSet && filter.routeSet.length > 0) {
            let routeSet = filter.routeSet;
            routeSet.forEach((val) => {
                if (val) filterStr += '&isRouteSet=' + val.toLowerCase();
            });
        }

        if (filter.authStatus && filter.authStatus.length > 0) {
            let authStatus = filter.authStatus;
            authStatus.forEach((val) => {
                if (val) filterStr += '&authStatus=' + val.toLowerCase() + '&isCodeSent=true';
            });
        }

        if (filter.productName) {
            filterStr += '&productName=' + filter.productName;
        }

        if (filter.pageNumber) {
            filterStr += '&pageNumber=' + filter.pageNumber;
        }

        if (filter.sortByBookingNote) {
            filterStr += '&sortBy=bookingNoteDateTime&isDescendingSort=false';
        }

        if (filter.bookingRouteStopItemActivityStatuses && filter.bookingRouteStopItemActivityStatuses.length > 0) {
            filter.bookingRouteStopItemActivityStatuses.forEach((status) => {
                filterStr += '&routeStopItemsActivityStatuses=' + status;
            });
        }

        if (filter.productCategories && filter.productCategories.length > 0) {
            let productCategories = filter.productCategories;
            productCategories.forEach((val) => {
                if (val) filterStr += '&productCategories=' + val.toLowerCase();
            });
        }
        if (filter.providerBookingStatus && filter.providerBookingStatus.length > 0) {
            filter.providerBookingStatus.forEach((status) => {
                filterStr += '&providerBookingStatus=' + status;
            });
        }
        if (filter.subscriptionStatus && filter.subscriptionStatus.length > 0) {
            let subscriptionStatus = filter.subscriptionStatus;
            subscriptionStatus.forEach((val) => {
                if (val) filterStr += '&subscriptionStatus=' + val.toUpperCase();
            });
        }

        if (filter.subscriptionTier && filter.subscriptionTier.length > 0) {
            let subscriptionTier = filter.subscriptionTier;
            subscriptionTier.forEach((val) => {
                if (val) {
                    if (val === 'Free Forever') {
                        filterStr += '&subscriptionTier=FREE_TIER&subscriptionStatus=ACTIVE';
                    } else {
                        filterStr += '&subscriptionTier=' + val.toUpperCase() + '&subscriptionStatus=ACTIVE';
                    }
                }
            });
        }

        if (filter.providerPaymentStatus && filter.providerPaymentStatus.length > 0) {
            filter.providerPaymentStatus.forEach((status) => {
                filterStr += '&providerPaymentStatus=' + status;
            });
        }
        if (filter.providerName) {
            filterStr += '&query=' + filter.providerName;
        }        
    }
    console.log({ filterStr });
    return filterStr;
};

// getCountryCode returns countryCode for given country
const getCountryCode = (country) => {
    // Defaulted to US
    let countryCode = '+1';

    switch (country) {
        case 'Australia':
            countryCode = '+61';
            break;
        case 'United Kingdom':
            countryCode = '+44';
            break;
        case 'New Zealand':
            countryCode = '+64';
            break;
        case 'Canada':
        case 'United States':
        default:
            break;
    }
    return countryCode;
};

const getNevigationItems = () => {
    return [
        {
            text: 'Planner',
            icon: PlaylistAddIcon,
            component: PlannerPage,
        },
        {
            text: 'Providers',
            icon: ShoppingBasketIcon,
            component: ProvidersPage,
        },
        {
            text: 'Routes',
            icon: LocationOnIcon,
            component: RoutesPage,
        },
        {
            text: 'Places',
            icon: PlacesIcon,
            component: PlacesPage,
        },
        { text: 'More to Explore', icon: ExploreIcon, component: MoreToExploreCollectionPage },
        { text: 'Connection Sparks', icon: SportsEsportsIcon, component: SparksPage },
        { text: 'Virtual Experiences', icon: HomeIcon, component: VirtualsPage },
        { text: 'Bulk Actions', icon: FileCopyIcon, component: BulkActionsPage },
        // { text: 'Microexperiences', icon: DonutSmallIcon, component: MicroexperienceManagerPage },
    ];
};

const getInternalBaseUrl = () => {
    return {
        planner: '/planner',
        providers: '/providers',
        routes: '/routes',
        places: '/places',
        moreToExploreCollection: '/moreToExploreCollection',
        sparks: '/sparks',
        virtuals: '/virtuals',
    };
};

const getCurrencySymbol = (country) => {
    let currencySymbol = '$';

    switch (country) {
        case 'United Kingdom':
            currencySymbol = '£';
            break;
        case 'New Zealand':
        case 'Canada':
        case 'United States':
        default:
            break;
    }
    return currencySymbol;
};

const getContactPhoneNumber = (country) => {
    let phoneNumber = '(800) 979-0589';
    switch (country) {
        case 'United Kingdom':
            phoneNumber = '020 7660 1433';
            break;
        case 'Australia':
            phoneNumber = '1300 307 750';
            break;
        case 'New Zealand':
            phoneNumber = '+61 1300 307 750';
            break;
        case 'Canada':
            phoneNumber = '(604) 800 2984';
            break;
        case 'United States':
        default:
            break;
    }
    return phoneNumber;
};

const getHumanReadableText = (key) => {
    if (!key) {
        return;
    }

    let responseText = '';

    // Handle `-`
    const keysWODashes = key.split('-');
    if (keysWODashes) {
        keysWODashes.forEach((t) => {
            responseText = `${responseText} ${getFirstCharCap(t)}`;
            responseText = responseText.replace(/Basket/, 'Keep Bag');
        });
    }

    if (!responseText) {
        return key;
    }

    return responseText.trim();
};

const getCustomisedTypes = () => {
    return [
        { name: 'Accomodation', value: 'accomodation' },
        { name: 'Food and Drink', value: 'eat-and-drinks' },
        { name: 'Everything Else We Love', value: 'other' },
    ];
};

const getBulkActionTypes = () => {
    return [
         'Assign an Owner',
          'Send gameplay',
          'Assign Routes'
    ];
};

const getUIElementType = () => {
    return {
        introduction: 'introduction',
        callOut: 'callOut',
        equipment: 'equipment',
        body: 'body',
        main: 'main',
        solution: 'solution',
        ending: 'ending',
        hard: 'hard',
        easy: 'easy',
        clueHard: 'clue-hard',
        clueEasy: 'clue-easy',
        hint: 'hint',
    };
};

const getUIElement = (data, type, subType = '') => {
    const uiElements = data || [];
    let uiElement = !isEmpty(subType) ? { type: type, subType: subType } : { type: type };
    uiElement =
        uiElements.find((uiElement) => {
            if (!isEmpty(subType)) {
                return uiElement.type === type && uiElement.subType === subType;
            }
            return uiElement.type === type && !uiElement.subType;
        }) || uiElement;

    const { medias = [], media = {} } = uiElement;
    if (isEmpty(media)) uiElement.media = medias[medias.length - 1]; // Pick last element as most probable the latest
    return cloneDeep(uiElement);
};

const getUIElementsWithMedias = (uiElements) => {
    uiElements.forEach((uiElement) => {
        const { media = {}, medias = [] } = uiElement;

        if (isEmpty(medias)) {
            if (!isEmpty(media)) medias.push(cloneDeep(media));
        } else {
            const lastMedia = medias[medias.length - 1] || { url: '' };
            if (!isEmpty(media) && media.url !== lastMedia.url) {
                medias.push(cloneDeep(media));
            }
        }
        delete uiElement.media;
        if (!isEmpty(medias)) uiElement.medias = medias;
    });

    return uiElements;
};

const getLatestMedia = (medias = [], media = {}) => {
    if (isEmpty(media.url) && !isEmpty(medias)) media = medias[medias.length - 1]; // Pick last element as most probable the latest
    return media;
};

const getMediaForUIName = () => {
    return {
        spark: 'spark',
        challenge: 'challenge',
        additionalFun: 'additional-fun',
        clue: 'clue',
        virtual: 'virtual',
        provider: 'provider',
        item: 'item',
        place: 'place',
        poi: 'poi',
        route: 'route',
        storyboard: 'storyboard',
    };
};

/**
 * A helper method to elminate on having more than one instances of the same media
 */
const isLastMediaSame = (medias = [], media = {}) => {
    let isSameStatus = true,
        lastMedia = {};

    lastMedia = !isEmpty(medias) ? medias[medias.length - 1] : lastMedia;

    const lastMediaUrl = lastMedia.url || '';
    const thisMediaUrl = media.url || '';
    if (!(lastMediaUrl === thisMediaUrl && !isEmpty(lastMediaUrl) && !isEmpty(thisMediaUrl))) {
        isSameStatus = false;
    }

    return isSameStatus;
};

/**
 * Get color based of status to indicate if an entity is active or archived
 */

const getIndicatorColor = (status) => {
    let color = 'transparent';
    if (status === 'inactive') {
        color = colors.acGold;
    } else if (status === 'archived') {
        color = colors.red;
    }

    return color;
};

const openPreviewWindow = (params, launchMode = 'AEX') => {
    const { eeeURL = '' } = config;

    const paramList = Object.keys(params).map((p) => `${p}=${params[p]}`);
    const launchModeParam = launchMode ? 'launchMode=' + launchMode : '?';

    const previewUrl = [eeeURL, [launchModeParam, ...paramList].join('&')].join('?');

    const width = 300;
    const height = 650;
    const x = window.screen.width / 2 - width / 2;
    const y = window.screen.height / 2 - height / 2;
    window.open(previewUrl, 'EEE', 'width=' + width + ',height=' + height + ',left = ' + x + ',top = ' + y);
};


const getCurrencies = () => {
    const currencies =  [
        { name: 'AUD', value: 'AUD' },
        { name: 'USD', value: 'USD' },
        { name: 'GBP', value: 'GBP' },
        { name: 'NZD', value: 'NZD' },
        { name: 'CAD', value: 'CAD' }
    ];
    return orderBy(currencies, ['name'], ['asc']);
};

const getCurrencyStyle = (currency) => {
    let style = {
        backgroundColor: '#52A8EF',
        color: 'white',
        borderColor: '#616161',
        borderWidth: '1px',
        borderStyle: 'none',
        dotColor: '',
        borderRadius: '16px',
    };
    if (isEmpty(currency)) return style;
    return style;
}

const getCurrencySymbolFromCurrencyShortcode = (currency) => {
    const currencySymbol = {
    AUD: '$', // Australian Dollar
    USD: '$', // US Dollar
    CAD: '$', // Canadian Dollar
    NZD: '$', // New Zealand
    EUR: '€', // Euro
    GBP: '£', // British Pound Sterling
    };
return currencySymbol[currency] ?? '$';
}

export {
    getFirstCharCap,
    getDecimalNumber,
    getStatusStyle,
    getStatuses,
    getFilterBarItems,
    getDays,
    getDietaries,
    getOptionalFilterControls,
    getFilterStr,
    getFirstCharLower,
    getConfirmationSentValues,
    getCodeSentValues,
    getRouteSetValues,
    getAuthStatusValues,
    getCountryCode,
    findValueByKey,
    findKeyByValue,
    findPaymentKeyByValue,
    getPaymentStatusStyle,
    getActivityStatusStyle,
    getNevigationItems,
    getInternalBaseUrl,
    getCurrencySymbol,
    getContactPhoneNumber,
    getBookingItemPaymentStatuses,
    getBookingItemActivityStatuses,
    getHumanReadableText,
    getCustomisedTypes,
    getUIElementType,
    getUIElement,
    getMediaForUIName,
    getUIElementsWithMedias,
    getProductCategories,
    getSubscriptionStatus,
    getSubscriptionTier,
    getLatestMedia,
    isLastMediaSame,
    getIndicatorColor,
    getProviderBookingStatuses,
    getProviderPaymentStatus,
    openPreviewWindow,
    getBulkActionTypes,
    getCodeSentValuesArray,
    providerItemStatusArray,
    getSimpleFilters,
    getCurrencies,
    getCurrencyStyle,
    getCurrencySymbolFromCurrencyShortcode
};
